export const AUTH = 'auth';
export const ENTITY = 'entity';
export const NAVIGATION = 'navigation';
export const NOTIFICATION = 'notification';
export const PREFERENCE = 'preference';
export const SCOPE = 'scope';

export const SLICES_TO_CACHE = [AUTH, ENTITY, NAVIGATION, PREFERENCE];
export const getLocalStoreSliceId = (slice) => `acta_${slice}`;
